// Oglinda lui `ACTIVE_LEGAL_VERSIONS` din
// `backend/auth/validators/registration.validators.js`.
//
// Cele două trebuie schimbate în ACELAȘI deploy, împreună cu textul publicat pe
// `miridar.com`. Dacă frontendul trimite o versiune pe care validatorul nu o
// recunoaște, backendul respinge înregistrarea cu `required_or_outdated` și
// formularul devine inutilizabil pentru toată lumea (REG-070).
export const ACTIVE_LEGAL_VERSIONS = Object.freeze({
  terms: "1.0",
  privacy: "1.0",
  dpa: "1.0",
});

export default ACTIVE_LEGAL_VERSIONS;
